import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/motion";

export default function Footer() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-border" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-20 sm:py-28">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-mono text-accent mb-6">Next step</p>
          <Link to="/contact" data-testid="footer-cta-link" className="group block">
            <span className="font-serif text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] block">
              Let's make the complex
            </span>
            <span className="font-serif italic text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] text-accent inline-flex items-center gap-4">
              clear &amp; credible
              <ArrowUpRight
                className="transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
                size={48}
              />
            </span>
          </Link>
        </Reveal>
        <div className="mt-16 pt-10 border-t border-border flex flex-col sm:flex-row justify-between gap-6 text-sm text-muted-foreground">
          <div className="flex flex-col gap-2">
            <span className="font-serif text-lg text-foreground">Twinkle Rajan</span>
            <span>Senior Visual &amp; Brand Designer — Delhi / Gurugram, India</span>
          </div>
          <div className="flex gap-8 items-start">
            {settings.public_email && (
              <a href={`mailto:${settings.public_email}`} data-testid="footer-email-link" className="hover:text-accent transition-colors">
                Email
              </a>
            )}
            {settings.linkedin_url && (
              <a href={settings.linkedin_url} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="hover:text-accent transition-colors">
                LinkedIn
              </a>
            )}
            <Link to="/work" data-testid="footer-work-link" className="hover:text-accent transition-colors">
              Work
            </Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-accent transition-colors">
              Admin
            </Link>
          </div>
        </div>
        <p className="mt-8 text-xs text-muted-foreground/70">
          © {new Date().getFullYear()} Twinkle Rajan. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
